const navigationCacheKey = `energikilden:venstremeny:v1`;

const getStorage = () => {
    try {
        return window.sessionStorage;
    }
    catch (_error) {
        return null;
    }
};

export const readNavigationCache = () => {
    const storage = getStorage();
    if (!storage) {
        return null;
    }
    try {
        return storage.getItem(navigationCacheKey);
    }
    catch (_error) {
        return null;
    }
};

export const writeNavigationCache = (value: unknown) => {
    const storage = getStorage();
    if (!storage) {
        return;
    }
    try {
        const serialized = JSON.stringify(value);
        if (serialized !== undefined) {
            storage.setItem(navigationCacheKey, serialized);
        }
    }
    catch (_error) {
        // Storage is optional; a full or restricted sessionStorage must not block navigation.
    }
};

export const clearNavigationCache = () => {
    const storage = getStorage();
    if (!storage) {
        return;
    }
    try {
        storage.removeItem(navigationCacheKey);
    }
    catch (_error) {
        // Storage is optional; logout and login must continue if it is unavailable.
    }
};
